<template>
  <div>
    <v-app>
      <!-- :mini-variant.sync="mini" -->
      <v-navigation-drawer
        app
        v-model="drawer"
        dark
        hide-overlay
      >
        <v-toolbar flat class="transparent">
          <v-list class="pa-0">
            <v-list-tile avatar>
              <v-list-tile-avatar>
                <img src="favicon.png">
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title>
                  <span>HYDROVAC</span>
                  <span class="font-weight-light">KING</span>
                </v-list-tile-title>
              </v-list-tile-content>

              <v-list-tile-action>
                <v-btn icon @click.stop="drawer = !drawer">
                  <v-icon>chevron_left</v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
        </v-toolbar>
        <v-list>
          <v-divider></v-divider>
          <v-list-tile @click="$vuetify.goTo('#home', {offset: -64}); drawer=!drawer;">
            <v-list-tile-action>
              <v-icon>home</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>HYDROVAC</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click="$vuetify.goTo('#ourtruck', {offset: -64}); drawer=!drawer;">
            <v-list-tile-action>
              <v-icon>local_shipping</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>OUR TRUCK</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click="$vuetify.goTo('#aboutus', {offset: -64}); drawer=!drawer;">
            <v-list-tile-action>
              <v-icon>info</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>ABOUT US</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click="$vuetify.goTo('#contactus', {offset: -64}); drawer=!drawer;">
            <v-list-tile-action>
              <v-icon>contact_mail</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>CONTACT US</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-navigation-drawer>

      <v-toolbar app>
        <v-toolbar-side-icon @click="drawer = !drawer" class="hidden-md-and-up"></v-toolbar-side-icon>
        <v-toolbar-title class="headline text-uppercase">
          <span>HYDROVAC</span>
          <span class="font-weight-light">KING</span>
        </v-toolbar-title>

        <!-- align-center justify-center -->
        <v-layout row class="hidden-sm-and-down">
          <v-btn flat @click="$vuetify.goTo('#home', {offset: -64})">
            <span class="mr-2">HYDROVAC</span>
            <v-icon right>home</v-icon>
          </v-btn>
          <v-btn flat @click="$vuetify.goTo('#ourtruck', {offset: -64})">
            <span class="mr-2">OUR TRUCK</span>
            <v-icon right>local_shipping</v-icon>
          </v-btn>
          <v-btn flat @click="$vuetify.goTo('#aboutus', {offset: -64})">
            <span class="mr-2">ABOUT US</span>
            <v-icon right>info</v-icon>
          </v-btn>
          <v-btn flat @click="$vuetify.goTo('#contactus', {offset: -64})">
            <span class="mr-2">CONTACT US</span>
            <v-icon right>contact_mail</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn flat disabled="">
            <span class="mr-2">705.229.9403</span>
            <v-icon right>phone</v-icon>
          </v-btn>
        </v-layout>
      </v-toolbar>

      <v-content id="home">
        <div class="home" data-aos="fadeIn">
          <v-img class="logo hidden-sm-and-down" src="../logo.png" max-height="300px" contain></v-img>
          <v-img class="logo hidden-md-and-up" src="../favicon.png" max-height="300px" contain></v-img>
        </div>
        <Home/>
      </v-content>
      <v-content id="ourtruck">
        <v-img src="../ourtruck.jpg" :height="window.height - 64"></v-img>
        <OurTruck/>
      </v-content>
      <v-content id="aboutus">
        <v-img src="../aboutus.jpg" :height="window.height - 64"></v-img>
        <AboutUs/>
      </v-content>
      <v-content id="contactus">
        <v-img src="../contactus.jpg" :height="window.height - 64"></v-img>
        <ContactUs/>
      </v-content>

      <v-footer class="pa-3 hidden-xs-only">
        <v-spacer></v-spacer>
        <div>HydrovacKing Ltd. &copy; {{ new Date().getFullYear() }}</div>
      </v-footer>
    </v-app>
  </div>
</template>

<script>
import * as easings from "vuetify/es5/util/easing-patterns";
import Home from "./components/Home";
import ContactUs from "./components/ContactUs";
import AboutUs from "./components/AboutUs";
import OurTruck from "./components/OurTruck";

export default {
  name: "App",
  components: {
    Home,
    ContactUs,
    AboutUs,
    OurTruck
  },
  data() {
    return {
      window: {
        width: 0,
        height: 0
      },
      drawer: false,
      mini: true
    };
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    }
  }
};
</script>

<style scoped>
.home {
  background-color: #FCFBF9;
  height: 100vh;
  position: relative;
}

.logo {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

v-card {
  min-height: 400px;
}
</style>